<template>
  <p
    class="body text-grey-900 cursor-pointer d-flex py-md-2 px-md-3"
    @click="logout"
  >
    <LockIcon class="text-grey-900 mb-1 mb-lg-0 me-lg-3" />
    {{ t('navbar.logout') }}
  </p>
</template>

<script lang="ts" setup>
  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Icons
  import LockIcon from '@/assets/LockIcon.vue'

  // Store
  import { useStore } from 'vuex'
  const store = useStore()

  // Computed
  const logout = (): void => {
    store.dispatch('auth/logout')
  }
</script>
